import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { AnimatePresence, motion } from "framer-motion";
import { typeStyle, units } from "@m/alchemy-theme";
export const List = styled.ul ``;
export const ListWrapper = styled.li ``;
export const AnimatedList = styled(motion.li) ``;
export const MenuListItemGroup = (props) => {
    const { children, isExpanded, ...rest } = props;
    if (isExpanded === undefined) {
        return (_jsx(ListWrapper, { ...rest, children: _jsx(List, { children: children }) }));
    }
    return (_jsx(AnimatePresence, { initial: false, children: isExpanded && (_jsx(AnimatedList, { initial: "collapsed", animate: "open", exit: "collapsed", variants: {
                open: { opacity: 1, height: "auto" },
                collapsed: { opacity: 0, height: 0 }
            }, transition: { duration: 0.34, ease: [0.04, 0.62, 0.23, 0.98] }, ...rest, children: _jsx(List, { children: children }) }, "content")) }));
};
export const Title = styled.h4 `
  ${typeStyle("labelL")};
  padding: ${units(2)} 0 ${units(0.5)} ${units(2.25)};
`;
export const MenuListItemGroupTitle = ({ children, ...rest }) => (_jsx("li", { ...rest, children: _jsx(Title, { children: children }) }));
